import * as yup from "yup";

export const BankSetupValidationSchema = yup.object().shape({
  bankCode: yup
  .string()
  .required("Bank Code is required")
  .max(4, "Maximum length 4 characters"),
	bankName: yup
  .string()
  .required("Bank Name is required")
  .max(100, "Maximum length 100 characters"),
  bankDomain: yup
  .string()
  .required("Bank Domain is required")
  .max(150, "Maximum length 150 characters"),
});
